import PropTypes, {object} from 'prop-types';
import React, {useMemo} from 'react';
import FastModal from './FastModal';
import MessageContainer from './MessageContainer';
import './MessageBox.scss';

const MESSAGE_TYPE = {
  WARNING: 'Warning',
  ERROR: 'Error',
};

const BUTTON_TYPE = {
  POSITIVE: 'Positive',
  NEGATIVE: 'Negative',
};

export const getMessageBoxContent = (message, messageType, confirmationMessage, messageTitle) => (
  <div className="message-box">
    {messageTitle && <div className="message-title">{messageTitle}</div>}
    {message && <MessageContainer messageType={messageType}>{message}</MessageContainer>}
    {confirmationMessage && <div className="content-confirmation-text">{confirmationMessage}</div>}
  </div>
);

export const getMessageBoxActionButtons = (buttonActions) => {
  const buttons = [];

  buttonActions.map((button) => {
    switch (button.type) {
      case BUTTON_TYPE.POSITIVE:
        return buttons.push({
          text: button.text,
          style: 'primary',
          handlerClick: () => button.clickHandler(),
          disabled: button.disabled,
        });
      case BUTTON_TYPE.NEGATIVE:
        return buttons.push({
          text: button.text,
          style: 'secondary',
          handlerClick: () => button.clickHandler(),
          disabled: false,
        });
      default:
        return null;
    }
  });

  return buttons;
};

const MessageBox = React.memo((props) => {
  const {message, messageType, confirmationMessage, messageTitle, messageClass, buttonActions, show, title, onClose} =
    props;

  const content = useMemo(() => {
    getMessageBoxContent(message, messageType, confirmationMessage, messageTitle);
  }, [message, messageType, confirmationMessage, messageTitle]);

  const actionButtons = useMemo(() => {
    getMessageBoxActionButtons(buttonActions);
  }, [buttonActions]);

  return (
    <FastModal
      isValid
      className={`message-box ${messageClass}`}
      show={show}
      btnAction={actionButtons}
      header={title}
      content={content}
      onClose={onClose}
      closeDisabled
      backdrop={false}
    />
  );
});

MessageBox.MessageType = MESSAGE_TYPE;
MessageBox.ButtonType = BUTTON_TYPE;

MessageBox.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string,
  messageType: PropTypes.string,
  message: PropTypes.string,
  confirmationMessage: PropTypes.string,
  messageClass: PropTypes.string,
  messageTitle: PropTypes.string,
  buttonActions: PropTypes.arrayOf(object).isRequired,
  onClose: PropTypes.func,
};

MessageBox.defaultProps = {
  title: '',
  messageType: MESSAGE_TYPE.WARNING,
  message: '',
  confirmationMessage: '',
  messageClass: '',
  messageTitle: '',
  onClose: () => {},
};

export default MessageBox;
